import IService from '../IService';

export default IService.extend({
  abort() {
    if (app.xhrExpected(this.req)) {
      this.req.abort();
    }
  },

  get(options) {
    options = _.options(options, {
      size: app.DASHBOARD_RESULTS_PER_PAGE,
      page: 0,
      q: '',
      programmerIds: '',
      marketplaceProgrammerIds: '',
      voiceOver: null,
      language: null,
      category: '',
      // in seconds
      minimumDuration: 0,
      maximumDuration: app.TIME.MAX_STORY_DURATION,
    });

    if (
      _.isEmpty(options.programmerIds) &&
      _.isEmpty(options.marketplaceProgrammerIds)
    ) {
      return Promise.resolve({ videos: [], noMore: true });
    }

    const rv = new _.ColdPromise();

    this.req = $.ajax({
      url: app.apiUrl('/api/v1/videos'),
      type: 'GET',
      data: options,

      error: (jqXHR, textStatus) => {
        if (textStatus !== 'abort') {
          rv.reject(this.createError(jqXHR));
        }
      },

      dataType: 'json',
      success: (response) => {
        if (_.isArray(response)) {
          rv.resolve({
            videos: response,
            noMore: !response || !response.length,
          });
        } else {
          rv.reject({ error: 'BAD_RESPONSE' });
        }
      },
    }).always(() => {
      this.req = null;
    });

    return rv;
  },
});
